export const SAVING_SUPPORT_SERVICE = 'SAVING_SUPPORT_SERVICE'
export const SAVED_SUPPORT_SERVICE = 'SAVED_SUPPORT_SERVICE'


export function supportService(
  supportService={
    isSaving: true,
    data: {},
  },
  action,
) {
  switch (action.type) {
    case SAVING_SUPPORT_SERVICE:
      return {
        ...supportService,
        isSaving: true,
      }
    case SAVED_SUPPORT_SERVICE:
      return {
        ...supportService,
        isSaving: false,
        data: action.supportService,
      }
    default:
      return supportService
  }
}
